import jwt_decode from 'jwt-decode';
import userPartners from './userPartners';
import accessControlsUtils from '@/utils/user/accessControlsUtils';

const STORE_NAME = 'user';

export default {
    name: STORE_NAME,
    namespaced: true,
    state: {
        loaded: false,
        accessControlsConfig: null,
        roles: [],
    },
    mutations: {
        setLoaded(state, loaded) {
            state.loaded = loaded;
        },
        setRoles(state, roles) {
            state.roles = roles;
        },
        setAccessControlsConfig(state, config) {
            state.accessControlsConfig = Object.assign({}, config);
        },
    },
    getters: {
        isLoaded: (state) => state.loaded,
        roles: (state) => state.roles,
        accessControlsConfig: (state) => state.accessControlsConfig,
        hasRole: (state) => (role) => {
            const accessControlsConfig = state.accessControlsConfig;

            return (
                accessControlsConfig &&
                accessControlsConfig.roles[role] &&
                accessControlsConfig.roles[role].active
            );
        },
    },
    actions: {
        setLoaded({ commit }, loaded) {
            commit('setLoaded', loaded);
        },
        setAccessControlsConfigByRoles({ commit }, roles) {
            commit('setAccessControlsConfig', accessControlsUtils.createConfig(roles));
        },
        tokenDecode({ commit }, token) {
            let decodedToken = jwt_decode(token);
            if (decodedToken && decodedToken.realm_access) {
                commit('setRoles', decodedToken.realm_access.roles);
                commit(
                    'setAccessControlsConfig',
                    accessControlsUtils.createConfig(decodedToken.realm_access.roles)
                );
            }
        },
    },
    modules: {
        partners: userPartners,
    },
};
